module.exports = __webpack_public_path__ + "static/media/arrow-up-small.419a99c8.svg";